import { Children, cloneElement, ComponentProps } from 'react';
import { Modal as ModalBase, Stack } from '~uikit';

type Props = ComponentProps<typeof ModalBase>;
const Modal = ({ children, ...rest }: Props) => {
  const { large } = rest;

  return (
    <ModalBase {...rest} style={{ height: large ? '100%' : 'unset' }}>
      <Stack
        axis="y"
        spacing="none"
        justify="space-between"
        style={{ height: '100%' }}
      >
        {Children.map(children, (child: any, i) =>
          cloneElement(child, { key: `modal-child-${i}` })
        )}
      </Stack>
    </ModalBase>
  );
};

export default Modal;
